import React, {Component} from 'react';
import {Card, CardHeader, Row, Col, CardBody, Input, Table} from 'reactstrap';
import {Dropdown, Button, Checkbox, Icon, Label} from "semantic-ui-react";
import './Style.scss';
import {MDBDataTable} from "mdbreact";
import 'react-dom';
import {connect} from "react-redux";
import apiConfig from "../../../axios/axios_api_services";
import axios_eventtag from "../../../axios/axios_eventtag";
import Cookies from "js-cookie";
import * as actionCreator from "../../../store/Action";
import * as common from "../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import * as routeConstants from "../../../const/route/Route";
import {Tooltip} from "antd";


class Question extends Component {
  state = {

    questions: [],
    event_list: [],
    eventSubEvents: [],
    subEventSessions: [],

    eventId: '', sessionId: '',
    startDate: '',
    endDate: '',
    subEventId: '',
  };

  getEvents = (status) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.CORPORATE_EVENTS({corporateId: corperateId}), {headers: headers})
      .then(async response => {
        this.props.spinnerHandler(false);

        if (response.data.success) {
          this.setState({event_list: response.data.eventList});
          if (status === "ON_LOAD") {
            let firstEventId = response.data.eventList.length !== 0 ? response.data.eventList[0].event_id : '';
            this.setState({
              eventId: firstEventId
            });
            this.getSubEvents(null, {value: firstEventId})
          }
        }
      })
      .catch(async error => {
        this.props.spinnerHandler(false);
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getEvents(status);
        } else {
          this.props.spinnerHandler(false)
        }
      })
      .finally(fin => {
      });
  };
  dropdownOnchange = name => (e, {value}) => {
    this.setState({
      subEventId: name === 'sessionId' ? this.state.subEventId : '',
      sessionId: '',
      questions: [],
      [name]: value,
    });

    switch (name) {
      case "eventId":
        this.getSubEvents(e, {value});
        break;
      case "subEventId":
        this.getSessions(e, {value});
        break;
      case "sessionId":
        this.getAllQuestions(e, {value});
        break;
      default:
        break;
    }
  };

  getSubEvents = (e, {value}) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.GET_SUBEVENT({event_id: value,corporateId: corperateId}), {headers: headers})
      .then(response => {

        this.props.spinnerHandler(false);

        if (response.data.success) {
          this.setState({eventSubEvents: response.data.subEventList});
          if (e === null) {
            let firstSubeventId = response.data.subEventList.length !== 0 ? response.data.subEventList[0].sub_event_id : '';
            this.setState({subEventId: firstSubeventId});
            this.getSessions(null, {value: firstSubeventId});
          }

        } else {
          this.setState({
            eventSubEvents: []
          })
        }
      })
      .catch(async error => {
        this.props.spinnerHandler(false);

        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getSubEvents(e, {value});
        }
      })
      .finally(fin => {
      });
  };

  getSessions = (e, {value}) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.GET_SUB_EVENT_SESSIONS({sub_event_id: value,corporateId: corperateId}), {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);

        if (response.data.success) {
          this.setState({subEventSessions: response.data.sessionList});
          if (e === null) {
            let firstSessionId = response.data.sessionList.length !== 0 ? response.data.sessionList[0].session_id : '';
            this.setState({sessionId: firstSessionId});
            this.getAllQuestions(null, {value: firstSessionId})
          }
        } else {
          this.setState({subEventSessions: []})
        }
      })
      .catch(async error => {
        this.props.spinnerHandler(false);

        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getSessions(e, {value});
        } else {
          this.props.spinnerHandler(false)
        }
      })
      .finally(fin => {
      });
  };

  getAllQuestions = (e, {value}) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.GET_ALL_QUESTIONS({session_id: value,corporateId: corperateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            questions: response.data.participantQuestionsList
          })
        } else {
          this.setState({
            questions: [],
            sessionId: value
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllQuestions(e, {value});
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  onStatusHandler = (status, type) => {
    swal({
      title: "Are you sure you want to continue?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.onStatusHandler_(status, type);
          break;
        default:
          break;
      }
    })
  };

  onStatusHandler_ = (value, type) => {
    let participantQuestionId = value.participant_question_id;
    let status = value.status !== "APPROVED" ? "APPROVED" : "REJECTED";
    if (type) {
      status = type;
    }
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.patch(apiConfig.APPROVE_REJECT_QUESTIONS({
      participant_question_id: participantQuestionId,
      status: status,
      corporateId: corperateId
    }), {}, {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);
        if (response.data.success) {
          common.notifyMessage("\"" + status + " \" Sucessfull", 2);
          this.getAllQuestions(null, {value: this.state.sessionId});
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.onStatusHandler_(value, type);
        } else {
          this.props.spinnerHandler(false);
        }
      })
      .finally(fin => {
      });
  };

  openQuestion = (id) => {
    swal({
      title: "Are you sure you want to continue?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {cancel: 'Cancel', dangerMode: {text: "Yes", value: "action", className: "okay-btn"}},
    }).then((value) => {
      switch (value) {
        case "action":
          this.openQuestion_(id);
          break;
        default:
          break;
      }
    });
  };

  openQuestion_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.post(apiConfig.OPEN_QUESTION({question_id: id, corporateId: corperateId}), {}, {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);
        if (response.data.success) {
          common.notifyMessage("The question was open", 2);
          this.getAllQuestions(null, {value: this.state.sessionId});
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.openQuestion_(id);
        } else {
          this.props.spinnerHandler(false);
        }
      })
      .finally(fin => {
      });
  };

  componentDidMount() {
    this.getEvents("ON_LOAD_");
  }

  render() {
    if (this.state.questions && this.state.questions !== 0) {
      this.state.questions.sort(function (a, b) {
        return b.is_selected - a.is_selected
      });
    }
    let elist = [];
    if (this.state.event_list !== null) {
      this.state.event_list.map((value, index) => {
        elist.push({
          text: value.event_name,
          value: value.event_id,
          key: value.event_id
        })
      })
    }
    let questionRows = [];
    let questionColumns = this.props.Question_data.columns;

    let subEventList = [];

    if (this.state.eventSubEvents.length !== 0) {
      this.state.eventSubEvents.map((value, index) => {
        subEventList.push({
          text: value.name,
          value: value.sub_event_id,
          key: value.sub_event_id
        });
      });
    }

    let sessions = [];
    if (this.state.subEventSessions.length !== 0) {
      this.state.subEventSessions.map((value, index) => {
        sessions.push({
          text: value.name,
          value: value.session_id,
          key: value.session_id
        })
      })
    }

    if (this.state.questions && this.state.questions.length !== 0) {
      this.state.questions.map((value, index) => {
        questionRows.push({
          // title: value.question_title,
          description: value.question_content,
          status: value.is_selected ? "OPEN" : value.status,
          action: <div>
            {
              !value.is_selected?
              value.status === "PENDING" ?
              <div>
                <Button style={{backgroundColor: '#ec2f2f', float: "right", color: "white"}}
                        onClick={(event) => this.onStatusHandler(value, "REJECTED")}>Reject</Button>
                <Button style={{backgroundColor: '#53bd52', float: "right", color: "white"}}
                        onClick={(event) => this.onStatusHandler(value, "APPROVED")}>Approve</Button></div>
              : value.status === "APPROVED" ?
                <div>
                  <Button onClick={() => this.openQuestion(value.participant_question_id)}
                          style={{backgroundColor: '#304d8a', float: "right", color: "white"}}>Open</Button>
                  <Button style={{backgroundColor: '#ec2f2f', float: "right", color: "white"}}
                          onClick={(event) => this.onStatusHandler(value, "REJECTED")}>Reject</Button></div>
                :
                <Button style={{backgroundColor: '#53bd52', float: "right", color: "white"}}
                        onClick={(event) => this.onStatusHandler(value, "APPROVED")}>Approve</Button>
            :null
            }
          </div>
        })
      })
    }
    return (
      <div className="event-org-questions">

        {
          this.props.usr_obj.userRoles !== "CORP_EVENT_ORGANIZER"?
            <Row>
              <Col className={"text-right"}>
                <Tooltip placement="topLeft" title="Open question screen">
                  <Label
                    onClick={() => window.open(routeConstants.QUESTION_BANK_ROUTE_PATH)}
                    color='red'  horizontal
                    style={{cursor: 'pointer'}}
                  >
                    {"Open Screen"}
                  </Label>
                </Tooltip>
              </Col>
            </Row>
            :null
        }

        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            {
              this.props.usr_obj.userRoles === "CORP_EVENT_ORGANIZER" ?
                <h4 className={"route-name-style"}>{this.props.route_name}</h4>
                : <h4 className={"route-none-style"}/>
            }
            <Card className="card1">
              <CardHeader>
                Filter Events
              </CardHeader>
              <Col lg={12}>
                <Row className={"search-event-row"}>
                  <Col lg={4} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Event'
                      fluid
                      selection search
                      options={elist}
                      value={this.state.eventId}
                      onChange={this.dropdownOnchange("eventId")}
                    />
                  </Col>
                  <Col lg={4} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Sub Event'
                      fluid
                      selection search
                      options={subEventList}
                      value={this.state.subEventId}
                      onChange={this.dropdownOnchange("subEventId")}
                    />
                  </Col>
                  <Col lg={4} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Session'
                      fluid search
                      value={this.state.sessionId}
                      selection
                      options={sessions}
                      onChange={this.dropdownOnchange("sessionId")}
                    />
                  </Col>
                </Row>
              </Col>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card className="card1">
              <CardHeader>
                Participant Questions for the Session
              </CardHeader>
              <Col lg={"12"}>
                <Row className={"search-event-row"}>
                  <Col lg={"12"} md={"12"}>
                    <MDBDataTable
                      striped
                      searching={true}
                      displayEntries={true}
                      bordered
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      hover
                      // className={"table thead th"}
                      data={{rows: questionRows, columns: questionColumns}}
                    />
                  </Col>
                </Row>
              </Col>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  test_alleventobject: state.eventReducer.allEventsObj,
  Question_data: state.organizerReducer.Event_Question_Table_data,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // all available cards
    receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data)),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Question);
